import { render, staticRenderFns } from "./PromotionParticipantsTable.vue?vue&type=template&id=424d17be"
import script from "./PromotionParticipantsTable.vue?vue&type=script&lang=js"
export * from "./PromotionParticipantsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports